import React from 'react';

import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PartnershipCardsBlock}
 */

const PartnershipCards = ({
    title,
    text,
    backgroundColor,
    partners
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;
    return (
        <section className={`${bgColor} col-wrapper-breakout rounded-lg flex-grow`}>
            <div className='col-padding py-24'>
                <h2 className='type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                    {title}
                </h2>
                {text && (
                    <p className='type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-6/12'>
                        {text}
                    </p>
                )}
                <div className='mt-64 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-16 grid'>
                    {partners.map((partner) => {
                        return (
                            <div
                                className='bg-surface-raised p-16 rounded-lg'
                                key={partner.id}>
                                <p className='type-style-sans-h3-med'>
                                    {partner.title}
                                </p>
                                {partner.text && (
                                    <p className='type-style-sans-body mt-8'>
                                        {partner.text}
                                    </p>
                                )}
                                {partner.ctaLabel && (
                                    <Button
                                        as='a'
                                        className='mt-16 button-outcome'
                                        href={formatLinkBlockToUrl(partner.ctaLink)}>
                                        {partner.ctaLabel}
                                    </Button>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PartnershipCards;
